import { FormControlLabel } from "@mui/material";
import { ChangeEvent } from "react";
import { alpha, styled, useTheme } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const CustomSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity),
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: theme.palette.primary.main,
    },
  }));

export default function BooleanField({
    label,
    id,
    name,
    value,
    isRequired,
    handleChange,
    index,
    disabled,
}: {
    label: string,
    id: string,
    name: string,
    value: boolean,
    isRequired: boolean,
    handleChange: (e: ChangeEvent<HTMLInputElement>, index?: number) => void,
    index?: number,
    disabled?: boolean,
}) {
    const theme = useTheme();

    return (
        <div className="w-full flex flex-col justify-start items-start gap-2 text-default">
            <label htmlFor={id} className={`text-[12px] font-medium ${isRequired && 'required'}`}>{label}</label>
            <FormControlLabel 
            control={
                <CustomSwitch 
                    onChange={(e: any) => handleChange(e, index)}
                    checked={value}
                    name={name}
                    size="small"
                    disabled={disabled}
                />
            } 
            label={value ? 'True' : 'False'}
            sx={{
                padding: '0 12px',
                border: `1px solid ${value ? theme.palette.primary.main : '#C1C7CD'}`,
                borderRadius: '8px',
                width: '100%',
                height: '44px',
                margin: 0,
                gap: '8px',
                '& .MuiFormControlLabel-label': {
                    fontFamily: 'Montserrat',
                    fontWeight: 500,
                    color: `${value ? theme.palette.primary.main : '#697077'}`
                },
                '&.MuiFormControlLabel-root': {
                   backgroundColor: `${value ? theme.palette.secondary.light : 'none'}`,

                   '&:hover': {
                    border: `1px solid ${theme.palette.primary.main}`
                   }
                },
            }}
            />
        </div>
    )
}